import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Getting Started with Canny Widgets';
const Description =
  'Embed a Canny widget to let your users post & vote on feedback from within your website or mobile app.';
const Image = 'https://canny.io/images/canny-social.png';

export default class WidgetDocsHomeHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://developers.canny.io/install/widget' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
